import { useNavigate, type NavigateFunction, useRoutes } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import routes from './config';

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
    window.scrollTo(0, 0);
  }, [navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [element]);

  return <Suspense fallback={<div></div>}>{element}</Suspense>;
}
